import { render, staticRenderFns } from "./SithMesInventoryPurchaseStorageInputList.vue?vue&type=template&id=38dbf8d9&scoped=true&"
import script from "./SithMesInventoryPurchaseStorageInputList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryPurchaseStorageInputList.vue?vue&type=script&lang=js&"
import style0 from "./SithMesInventoryPurchaseStorageInputList.vue?vue&type=style&index=0&id=38dbf8d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbf8d9",
  null
  
)

export default component.exports